/**
 * Vehicle class formatter utility
 * Converts enum values to human-readable display text
 */

/**
 * Format vehicle class enum to display text
 * 
 * @param {string} classEnum - Vehicle class enum value
 * @returns {string} Human-readable class name
 * 
 * @example
 * formatVehicleClass('full_size_sedan') // 'Full Size Sedan'
 * formatVehicleClass('luxury') // 'Luxury'
 */
export const formatVehicleClass = (classEnum) => {
  const classMap = {
    'basic_economy': 'Basic Economy',
    'full_size_sedan': 'Full Size Sedan',
    'newer_sedan_suv': 'Newer Sedan/SUV',
    'luxury': 'Luxury'
  };
  
  return classMap[classEnum] || classEnum;
};

/**
 * Get all vehicle classes for dropdowns
 * 
 * @returns {Array} Array of {value, label} objects
 * 
 * @example
 * getVehicleClasses()
 * // [
 * //   { value: 'basic_economy', label: 'Basic Economy' },
 * //   { value: 'full_size_sedan', label: 'Full Size Sedan' },
 * //   ...
 * // ]
 */
export const getVehicleClasses = () => {
  return [
    { value: 'basic_economy', label: 'Basic Economy' },
    { value: 'full_size_sedan', label: 'Full Size Sedan' },
    { value: 'newer_sedan_suv', label: 'Newer Sedan/SUV' },
    { value: 'luxury', label: 'Luxury' }
  ];
};

export default {
  formatVehicleClass,
  getVehicleClasses
};
